module.exports = __webpack_public_path__ + "static/media/hydroponic_farming_Setup.d019a370.png";